// Wer ist angemeldet. Die eine Abfrage, an der alles Weitere haengt.

import { useQuery } from "@tanstack/react-query";
import { merkeCsrfToken } from "./api.js";
import { holeBundleMitCache } from "./offlineBundle.js";

export interface Sammlung {
  id: number;
  kind: "personal" | "shared";
  name: string;
  role: "owner" | "member";
}

export interface Nutzer {
  id: string;
  email: string;
  displayName: string | null;
  status: "pending" | "active" | "disabled";
  role: "admin" | "user";
  settings: Record<string, unknown>;
}

export interface MeAntwort {
  angemeldet: boolean;
  nutzer?: Nutzer;
  sammlungen?: Sammlung[];
  csrfToken?: string;
}

/**
 * Ausnahme von der deutschen Benennung: React erkennt einen Hook am
 * Praefix "use", und der Linter setzt das durch (rules-of-hooks).
 */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    // Nicht aus dem Cache beantworten: Wer gerade freigeschaltet wurde, soll
    // das beim naechsten Blick sehen und nicht erst nach einer Minute. Der
    // IndexedDB-Fallback in holeBundleMitCache() greift trotzdem, aber nur
    // wenn die Anfrage selbst scheitert (kein Netz) - sonst zaehlt immer
    // die frische Antwort. Ohne diesen Fallback wuerde ein Neuladen ohne
    // Netz schon an der Anmeldepruefung scheitern, bevor der Hauptscreen
    // ueberhaupt die eigenen Offline-Daten zeigen kann (Projektplan 10.1).
    staleTime: 0,
    queryFn: async () => {
      const antwort = await holeBundleMitCache<MeAntwort>("me", "/me");
      // csrfToken faellt aus dem Cache nie stumpf falsch aus: Er gehoert zur
      // Sitzung (sitzung.ts), nicht zur Anfrage, und aendert sich erst mit
      // einer neuen Anmeldung.
      merkeCsrfToken(antwort.csrfToken ?? null);
      return antwort;
    },
  });
}
